<template>
    <div id="carouselDeliverers"  class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
            <li data-target="#carouselDeliverers" data-slide-to="0" class="active"></li>
            <li data-target="#carouselDeliverers" data-slide-to="1" ></li>
            <li data-target="#carouselDeliverers" data-slide-to="2" ></li>
        </ol>
        <div class="carousel-inner">
            <div class="carousel-item active">
                <img src="delivery_imgs/delivery_img_1.jpg" class="d-block w-100" alt="Delivery Image 1"/>
            </div>
            <div class="carousel-item">
                <img src="delivery_imgs/delivery_img_2.jpg" class="d-block w-100" alt="Delivery Image 2"/>
            </div>
            <div class="carousel-item">
                <img src="delivery_imgs/delivery_img_3.jpg" class="d-block w-100" alt="Delivery Image 3"/>
            </div>
            <a class="carousel-control-prev" href="#carouselDeliverers" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselDeliverers" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Slider"
    }
</script>

<style scoped>

</style>
